import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import {TranslationService} from './ui/i18n';
// language list
import {locale as enLang} from './ui/i18n/vocabs/en';
import {locale as esLang} from './ui/i18n/vocabs/es';
import { AnalyticsService } from './domain/services/analytics.service';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'body[root]',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private routerSubscription?: Subscription;

  constructor(
    private translationService: TranslationService,
    private router: Router,
    private analyticsService: AnalyticsService,
  ) {
    // register translations
    this.translationService.loadTranslations(
      enLang,
      esLang
    );
  }

  ngOnInit() {
    this.routerSubscription = this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event) => {
      const path = event.urlAfterRedirects || event.url;
      this.analyticsService.trackPageView(
        path,
        document.title,
      );
      if (path === '/' || path === '/dashboard') {
        this.analyticsService.trackHomeWatched(path);
      }
    });
  }

  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
  }
}
